export const generateRandomString = (length: number) => {
  const allowed = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const getRandomCharacter = () => allowed.charAt(Math.floor(Math.random() * allowed.length));
  const chars = Array.from(Array(length), getRandomCharacter);

  return chars.join('');
};

export const toSentenceCase = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);
